import { FormField } from "@/components/ui/form"
import {
  LabelAndSelectValue,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface SelectFormFieldProps {
  fieldName: string
  label: string
  options: {
    label: string
    value: string
  }[]
}

const SelectFormField = ({ fieldName, label, options }: SelectFormFieldProps) => {
  const findOptionLabel = (value: string) => options.find((option) => option.value === value)?.label ?? ""

  return (
    <FormField
      name={fieldName}
      render={({ field: { value, onChange } }) => (
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger data-testid={`select-trigger-${fieldName}`}>
            <SelectValue placeholder={label}>
              <LabelAndSelectValue label={label} value={findOptionLabel(value)} />
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value} data-testid={`select-option-${option.value}`}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    />
  )
}

export { SelectFormField }
